import { Grid, Card, CardContent, Skeleton, Box } from "@mui/material";
import { useTheme } from "../../style/theme";

const PlanSkeleton = ({ isMobile = false }) => {
  const { mode } = useTheme();

  return (
    <Grid container spacing={0} sx={{ p: 4, justifyContent: "center" }}>
      {[...Array(4)].map((_, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          key={index}
          sx={{
            px: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            borderRadius: 8,
          }}
        >
          <Card
            sx={{
              height: 550,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              background: mode === "dark" ? "#141414" : "#fff",
              color: "#fff",
              borderRadius: 6,
              paddingY: isMobile ? 2 : 4,
              paddingX: isMobile ? 2 : 0,
            }}
          >
            <CardContent
              sx={{ display: "flex", flexDirection: "column", height: "100%" }}
            >
              {/* Header */}
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}
              >
                <Skeleton
                  variant="circular"
                  width={isMobile ? 36 : 48}
                  height={isMobile ? 36 : 48}
                />
                <Box>
                  <Skeleton width={80} height={20} />
                  <Skeleton width={60} height={25} />
                </Box>
              </Box>

              {/* Description */}
              <Skeleton
                variant="rectangular"
                width="100%"
                height={100}
                sx={{ mb: 2 }}
              />

              {/* Price */}
              <Box sx={{ mb: 2 }}>
                <Skeleton width={100} height={30} />
              </Box>

              {/* Button */}
              <Box
                sx={{
                  marginBottom: "20px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Skeleton
                  variant="rectangular"
                  width="90%"
                  height={50}
                  sx={{ borderRadius: 3 }}
                />
              </Box>

              {/* Features */}
              <Box sx={{ width: "100%" }}>
                <Skeleton width="100%" height={30} sx={{ mb: 2 }} />
                {[...Array(4)].map((_, idx) => (
                  <Box
                    key={idx}
                    sx={{ display: "flex", alignItems: "center", mb: 1 }}
                  >
                    <Skeleton
                      variant="circular"
                      width={20}
                      height={20}
                      sx={{ mr: 1 }}
                    />
                    <Skeleton width="80%" height={20} />
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default PlanSkeleton;
